import { EStyleType } from './enums';

export const ColorMap = {
  [EStyleType.INFO_0]: '--info-color',
  [EStyleType.WARNING_1]: '--warning-color',
  [EStyleType.DANGER_2]: '--danger-color',
  [EStyleType.SECONDARY_3]: '--secondary-color',
  [EStyleType.NEUTRAL_4]: '--neutral-color',
};

export const CSSClassMap = {
  [EStyleType.INFO_0]: 'info',
  [EStyleType.WARNING_1]: 'warning',
  [EStyleType.DANGER_2]: 'danger',
  [EStyleType.SECONDARY_3]: 'secondary',
  [EStyleType.NEUTRAL_4]: 'neutral',
};
